/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Rights_Toast_Subject_AddedInputs */



/**
* | output |
* | --- |
* | "Added {count} overrides." |
*
* @param {Rights_Toast_Subject_AddedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_toast_subject_added = /** @type {((inputs: Rights_Toast_Subject_AddedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Toast_Subject_AddedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Ausnahmen hinzugefügt.`)
	return /** @type {LocalizedString} */ (`Added ${i?.count} overrides.`)
});